export default __webpack_public_path__ + "static/media/bulk.b4df95dc.JPG";